import { isCaseworker, isClient, } from '@debbie/common/dist/permissions/index.js';
import { logout } from '@debbie/cortex/dist/auth/actions.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { useAccessCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { init } from '@debbie/cortex/dist/socket.js';
import { setTenantId, useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import AccountSelectorPage from './AccountSelectorPage/AccountSelectorPage.js';
import Button from './Button.js';
import PlaceholderLoader from './PlaceholderLoader.js';
const Authenticate = (props) => {
    const authToken = useSelector(selectAuthToken);
    const meLoadable = useMe();
    const tenantId = useTenantId();
    const creditorId = useSelector((s) => s.selectedCreditor);
    const site = useSelector((r) => r.site);
    // Authenticate component should only be used when the user is logged in
    if (typeof authToken !== 'string') {
        return React.createElement(ErrorPage, null, " User not logged in. ");
    }
    if (new URLSearchParams(window.location.search).get('nu_token')) {
        logout(location.href);
    }
    // Not authenticated
    if (h.isError(meLoadable)) {
        if (meLoadable.error.message === 'Bad token') {
            logout();
            return null;
        }
        return (React.createElement(ErrorPage, null, " Error loading user info. Reload to try again. "));
    }
    if (!h.hasData(meLoadable)) {
        return React.createElement(SeamlessLoadingPage, null);
    }
    if (!tenantId || !checkIfTenantIdMatchesTenantId(tenantId, meLoadable.data)) {
        if (meLoadable.data.tenants.length === 1) {
            const tenantId = meLoadable.data.tenants[0].id;
            setTenantId(tenantId);
            init(authToken, tenantId);
            return;
        }
        return React.createElement(AccountSelectorPage, null);
    }
    // Is verified to exist in checkIfTenantIdMatchesTenantId
    const tenant = meLoadable.data.tenants.find((t) => t.id === tenantId);
    if (site === 'client') {
        if (!isClient(tenant.role) && !isCaseworker(tenant.role)) {
            logout();
            return null;
        }
        if (!creditorId) {
            return React.createElement(ValidateAccessToCreditorWebapp, null);
        }
        else {
            return (React.createElement(DoesUserHaveAccessToSelectedCreditor, { creditorId: creditorId, children: props.children }));
        }
    }
    if (site === 'caseworker' && !isCaseworker(tenant.role)) {
        return React.createElement(AccountSelectorPage, null);
    }
    return props.children;
};
export default Authenticate;
const ValidateAccessToCreditorWebapp = () => {
    const creditorsHavingAccessToLoadable = useAccessCreditors();
    const creditorsHavingAccessTo = h.hasData(creditorsHavingAccessToLoadable)
        ? creditorsHavingAccessToLoadable.data
        : [];
    if (h.isLoading(creditorsHavingAccessToLoadable)) {
        return React.createElement(SeamlessLoadingPage, null);
    }
    if (h.hasData(creditorsHavingAccessToLoadable)) {
        if (creditorsHavingAccessTo.length === 1) {
            c.creditors.select(creditorsHavingAccessTo[0].creditorId);
        }
    }
    else {
        return React.createElement(SeamlessLoadingPage, null);
    }
    return React.createElement(AccountSelectorPage, null);
};
const DoesUserHaveAccessToSelectedCreditor = (props) => {
    const tenantId = useTenantId();
    const creditorsHavingAccessToLoadable = useAccessCreditors();
    const creditorsHavingAccessTo = h.hasData(creditorsHavingAccessToLoadable)
        ? creditorsHavingAccessToLoadable.data
        : [];
    if (h.isLoading(creditorsHavingAccessToLoadable)) {
        return React.createElement(SeamlessLoadingPage, null);
    }
    if (h.hasData(creditorsHavingAccessToLoadable)) {
        if (creditorsHavingAccessTo.some((c) => c.creditorId === props.creditorId)) {
            // Validate if the creditors tenantId is matching the selected tenantId
            if (creditorsHavingAccessTo.some((c) => c.tenantId === tenantId)) {
                return props.children;
            }
            else {
                return React.createElement(AccountSelectorPage, null);
            }
        }
        else {
            // Use is not having access to the creditor
            c.creditors.select('');
            return React.createElement(AccountSelectorPage, null);
        }
    }
    else {
        return React.createElement(SeamlessLoadingPage, null);
    }
};
const SeamlessLoadingPage = () => {
    return React.createElement(PlaceholderLoader, null);
};
const ErrorPage = (props) => {
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        } },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem',
            } },
            React.createElement("div", null, props.children),
            React.createElement(Button, { onClick: () => {
                    logout();
                } }, "Log out"))));
};
const checkIfTenantIdMatchesTenantId = (tenantId, me) => {
    return me.tenants.some((t) => t.id === tenantId);
};
//# sourceMappingURL=Authenticate.js.map